export default {
    intro: 'Hãy xem nghĩa và chọn từ phù hợp!',
    th: {
        order: 'Số thứ tự',
        meaning: 'Câu hỏi',
        answer: 'Đáp án đúng',
        wrong: 'Đáp án sai',
        wrongChoices: 'Đáp án sai',
        correctRate: 'Độ chính xác',
    },
    manySelectedWrongAnswer: 'Đáp án sai được chọn nhiều nhất',
    teacher: {
        setting: {
            addQuestion: 'Thêm câu hỏi',
            searchCount: '{count} kết quả tìm kiếm',
            defaultBadge: 'Mặc định',
            otherCount: '+{count} khác',
            waitHeader: 'Từ chờ đăng ký ({count})',
            clearAll: 'Xóa tất cả',
            registerCount: 'Thêm {count} vào hoạt động',
            sameWordBadge: 'Cùng từ đầu mục',
            emptyMeaningBadge: 'Không có nghĩa',
            autoExtract: 'Tự động điền',
            delete: 'Xóa',
            close: 'Đóng',
        },
        modal: {
            clearConfirm: {
                title: 'Xóa tất cả từ vựng đang chờ?',
                message: 'Tất cả từ vựng đang chờ sẽ bị xóa. Tiếp tục?',
            },
            closeConfirm: {
                title: 'Hủy nội dung đã nhập?',
                message: 'Đóng sẽ xóa tất cả từ trong danh sách chờ. Tiếp tục?',
            },
            questionDelete: {
                title: 'Xóa câu hỏi này?',
                // {word}: từ đầu mục của câu hỏi cần xóa. Cảnh báo sẽ bị xóa vĩnh viễn khỏi hoạt động.
                message: "Câu hỏi '{word}' sẽ bị xóa khỏi hoạt động. Tiếp tục?",
            },
            waitItemDelete: {
                title: 'Xóa từ vựng đang chờ?',
                // {word}: từ vựng đang chờ cần xóa. Chỉ xóa khỏi hàng đợi; hoạt động không bị ảnh hưởng.
                message: "Xóa '{word}' khỏi danh sách chờ. Tiếp tục?",
            },
            // {count}: số từ bị bỏ qua do trùng lặp trong từ điển
            duplicateNotice: '{count} từ đã được đăng ký nên không được thêm.',
            // {count}: số từ bị bỏ qua vì không có nghĩa
            skippedNotice: '{count} từ không có nghĩa nên không được thêm.',
            // Xác nhận khi trộn lẫn từ không có nghĩa với từ hợp lệ
            mixedEmptyConfirm: {
                title: 'Đăng ký?',
                line1: '{empty} từ không có nghĩa sẽ không được thêm.',
                line2: 'Chỉ đăng ký {valid} từ còn lại?',
            },
            // Thông báo khi chỉ còn lại từ không có nghĩa
            onlyEmptyNotice: {
                title: 'Không thể đăng ký',
                message: 'Không có từ nào để đăng ký. Chỉ còn lại các từ không có nghĩa.',
            },
            registerFailed: 'Không thể thêm.',
        },
    },
};
